import React from 'react';

class TCWGlobal extends React.Component {
  render() {
    return (
      <div className="content tcwglobal theme-tcwglobal">
        <div className="keywords">
          <p className="content-title"><span>k</span>eywords</p>
          <div className="content-article">
            <div className="keywords__row"><p className="keywords__label">Position</p><p className="keywords__value">Full-stack Software Engineer II</p></div>
            <div className="keywords__row"><p className="keywords__label">Skills</p><p className="keywords__value">PHP · Yii2 · Next.js · TypeScript · React · AI-assisted Development</p></div>
            <div className="keywords__row"><p className="keywords__label">Focus</p><p className="keywords__value">Legacy to Modern Migration · Employee Onboarding · HR & Workforce Systems · Production Support</p></div>
          </div>
        </div>
        <p className="content-title"><span>a</span>bstract</p>
        <div className="content-article content-article-paragraphs">
          <img className="tcwglobal-logo" src={require('./../images/tcwglobal_logo.svg')} alt={'TCWGlobal Logo'} />
          <p>
            TCWGlobal is a global workforce solutions company that helps organizations hire, manage, and support 
            workers across the entire employment lifecycle, from hiring and onboarding to payroll, compliance, and 
            ongoing employee support. By combining workforce expertise with technology, TCWGlobal simplifies complex 
            HR operations for clients, workers, and internal teams.
          </p>
          <p>
            I joined TCWGlobal as a Full-stack Software Engineer during a key transition in the company's technology 
            stack. I contributed to migrating the core HR platform from legacy PHP (Yii2) to Next.js (TypeScript) 
            and React, owning the employee onboarding migration end to end while keeping the existing systems 
            running, and brought AI-assisted development into my everyday workflow.
          </p>
          <p>
            This role reinforced my belief that strong technical execution starts with a clear understanding of the 
            business behind it. Collaborating with talented engineers and colleagues across teams sharpened my ability 
            to turn business requirements into practical, maintainable, and scalable solutions.
          </p>
        </div>
        <p className="content-title"><span>e</span>xperience</p>
        <div className="content-article content-article-list">
          <p>• Contributed to migrating the company's core HR platform from legacy PHP (Yii2) to a modern web stack using Next.js (TypeScript) and React, owning the migration of the employee onboarding process end to end</p>
          <p>• Maintained and enhanced the existing PHP (Yii2) HR process systems during the migration</p>
          <p>• Provided real-time urgent response and troubleshooting for production issues</p>
        </div>
        <p className="content-title"><span>p</span>rojects</p>
        <div className="content-article content-article-list">
          <p>• StaffingNation V1</p>
          <p>• StaffingNation V2</p>
        </div>
        <p className="content-title"><span>a</span>chivement</p>
        <div className="content-article content-article-list content-final">
          <p>• Advanced AI-assisted development practices and workflows</p>
          <p>• Deepened expertise in end-to-end HR & workforce management processes</p>
          <p>• Strengthened business-driven software design and problem-solving skills</p>
        </div>
      </div>
    );
  }
}

export default TCWGlobal;
